export default __webpack_public_path__ + "static/media/DrivUp.04cb0385.svg";